<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TMapGeofenceArea',
})
</script>
<template>
  <div>
    <BdBtn v-if="editing" type="primary" danger :icon="CheckCircleFilled" @click.stop="$emit('closeEdit')">完成编辑</BdBtn>
    <div :class="bem()" v-else>
      <div :class="bem('text')">区域{{ index + 1 }}</div>
      <FormOutlined v-if="editVisible" @click.stop="$emit('edit')" :class="bem('edit')" title="编辑区域" />
      <Popconfirm title="确定删除该区域？" @confirm="$emit('del')">
        <DeleteOutlined v-if="delVisible" @click.stop :class="bem('del')" title="删除区域" />
      </Popconfirm>
    </div>
  </div>
</template>

<script lang="ts" setup name="TMapGeofenceArea">
import { CheckCircleFilled, DeleteOutlined, FormOutlined } from '@ant-design/icons-vue'
import { createNamespace } from '@bd/vue3-utils'
import { Popconfirm } from 'ant-design-vue'
import { BdBtn } from '-/Common/BdBtn'

withDefaults(
  defineProps<{
    index: number
    editing?: boolean
    editVisible?: boolean
    delVisible?: boolean
  }>(),
  {
    editing: false,
    editVisible: true,
    delVisible: true
  }
)
defineEmits(['edit', 'del', 'closeEdit'])
const [_, bem] = createNamespace('TMapGeofenceArea')
</script>

<style lang="less">
.t-map-geofence-area {
  display: flex;
  align-items: center;
  height: 32px;
  padding: 4px 15px;
  border: @border-dashed;
  border-radius: @border-radius-base;
  font-size: 14px;
  background: @white;
  transition: all 0.3s;
  cursor: pointer;
  box-shadow: @btn-shadow;

  &:hover {
    border-color: @primary-color;
    color: @primary-color;
  }

  &__text {
    flex: 1;
    user-select: none;
  }

  &__edit {
    margin-left: @margin-xs;
    .active;
  }

  &__del {
    margin-left: @margin-xs;
    .active(@error-color);
  }
}
</style>
